<form *ngIf="profileTypePropertyDto; else loading" #propertyForm="ngForm">
  <div class="mt-27 mct-flex mct-col mct-gap-20"  >
    <div class="mct-flex mct-row mct-gap-10"  >
      <div class="mct-flex mct-col" >
        <label>{{ 'profiles.edit.profile-type.property.number-of-buildings-in-property' | translate | titlecase }}</label>
        <input name="numberOfBuildings" type="number" [(ngModel)]="profileTypePropertyDto.NumberOfBuildings" />
      </div>
      <div class="mct-flex mct-col" >
        <label>{{ 'profiles.edit.profile-type.property.number-of-units' | translate | titlecase }}</label>
        <input name="numberOfUnits" type="number" [(ngModel)]="profileTypePropertyDto.NumberOfUnits" />
      </div>
    </div>

    <div class="mct-flex mct-row mct-gap-10"  >
      <div class="mct-flex mct-col" >
        <label>{{ 'profiles.edit.profile-type.property.housing-type' | translate | titlecase }}</label>
        <p-select
          name="housingType"
          [placeholder]="'profiles.edit.profile-type.property.select' | translate"
          [options]="housingCategoryTypeItems"
          [(ngModel)]="profileTypePropertyDto.HousingTypeId"
        ></p-select>
      </div>
      <div class="mct-flex mct-col" >
        <label>{{ 'profiles.edit.profile-type.property.property-management-type' | translate | titlecase }}</label>
        <p-select
          name="propertyType"
          [placeholder]="'profiles.edit.profile-type.property.select' | translate"
          [options]="propertyTypeItems"
          [(ngModel)]="profileTypePropertyDto.PropertyTypeId"
        ></p-select>
      </div>
    </div>

    <div class="mct-flex mct-col" >
      <label>{{ 'profiles.edit.profile-type.property.year-built' | translate | titlecase }}</label>
      <input name="yearBuilt" type="number" [(ngModel)]="profileTypePropertyDto.YearBuilt" />
    </div>

    <div class="mct-flex mct-col" >
      <label>{{ 'profiles.edit.profile-type.property.housing-category' | translate | titlecase }}</label>
      <div class="mct-flex mct-row mct-wrap mct-gap-10"  >
        <p-checkbox
          name="housingCategoryCorporate"
          binary="true"
          [(ngModel)]="profileTypePropertyDto.HousingCategoryCorporate"
          inputId="housingCategoryCorporate"
        >
        </p-checkbox>
        <label for="housingCategoryCorporate">
          {{ 'profiles.edit.profile-type.property.corporate' | translate | titlecase }}
        </label>
        <p-checkbox
          name="housingCategoryStudent"
          binary="true"
          [(ngModel)]="profileTypePropertyDto.HousingCategoryStudent"
          inputId="housingCategoryStudent"
        >
        </p-checkbox>
        <label for="housingCategoryStudent">
          {{ 'profiles.edit.profile-type.property.student' | translate | titlecase }}
        </label>
        <p-checkbox
          name="housingCategoryConventional"
          binary="true"
          [(ngModel)]="profileTypePropertyDto.HousingCategoryConventional"
          inputId="housingCategoryConventional"
        >
        </p-checkbox>
        <label for="housingCategoryConventional">
          {{ 'profiles.edit.profile-type.property.conventional' | translate | titlecase }}
        </label>
        <p-checkbox
          name="housingCategoryMixedUse"
          binary="true"
          [(ngModel)]="profileTypePropertyDto.HousingCategoryMixedUse"
          inputId="housingCategoryMixedUse"
        >
        </p-checkbox>
        <label for="housingCategoryMixedUse">
          {{ 'profiles.edit.profile-type.property.mixed-use' | translate | titlecase }}
        </label>
        <p-checkbox
          name="housingCategoryMilitary"
          binary="true"
          [(ngModel)]="profileTypePropertyDto.HousingCategoryMilitary"
          inputId="housingCategoryMilitary"
        >
        </p-checkbox>
        <label for="housingCategoryMilitary">
          {{ 'profiles.edit.profile-type.property.military' | translate | titlecase }}
        </label>
        <p-checkbox
          name="housingCategoryTaxCredit"
          binary="true"
          [(ngModel)]="profileTypePropertyDto.HousingCategoryTaxCredit"
          inputId="housingCategoryTaxCredit"
        >
        </p-checkbox>
        <label for="housingCategoryTaxCredit">
          {{ 'profiles.edit.profile-type.property.tax-credit' | translate | titlecase }}
        </label>
        <p-checkbox
          name="housingCategorySenior"
          binary="true"
          [(ngModel)]="profileTypePropertyDto.HousingCategorySenior"
          inputId="housingCategorySenior"
        >
        </p-checkbox>
        <label for="housingCategorySenior">
          {{ 'profiles.edit.profile-type.property.senior' | translate | titlecase }}
        </label>
        <div class="mct-flex mct-row mct-gap-10"  >
          <p-checkbox
            name="housingCategoryOther"
            binary="true"
            [(ngModel)]="profileTypePropertyDto.HousingCategoryOther"
            inputId="housingCategoryOther"
          >
          </p-checkbox>
          <label for="housingCategoryOther">
            {{ 'profiles.edit.profile-type.property.other' | translate | titlecase }}
          </label>
          <input
            *ngIf="profileTypePropertyDto.HousingCategoryOther"
            type="text"
            name="housingCategoryOtherValue"
            [(ngModel)]="profileTypePropertyDto.HousingCategoryOtherValue"
          />
        </div>
      </div>
    </div>
  </div>
</form>
<ng-template #loading>
  <div class="mt-27">
    <wl-busy></wl-busy>
  </div>
</ng-template>
